<template>
  <div>
    <!--    <div class="panel-title position-relative w-100 title">-->
    <!--      <p>{{ $t('pages.project-page.title') }}</p>-->
    <!--    </div>-->
    <div class="component-roomtypes">
      <b-modal
        id="projectPageModal"
        ref="projectPageModal"
        no-fade
        centered
        static
        size="lg"
        modal-class="form-modal"
        :ok-title="$t(`buttons.${projectPage.id != null ? 'update' : 'save'}`)"
        ok-variant="primary"
        :cancel-title="$t('buttons.cancel')"
        cancel-variant="outline-primary"
        :ok-disabled="updatePending || !$refs.projectPageForm || !formValid || !$refs.projectPageForm.flags.valid"
        :cancel-disabled="updatePending"
        :no-close-on-esc="updatePending"
        :no-close-on-backdrop="updatePending"
        :hide-header-close="updatePending"
        @show="modalScroll"
        @hidden="modalScroll"
        @ok.prevent="processForm"
      >
        <template #modal-header-close>
          <icon width="20" height="20" class="d-none d-md-block" type="times"/>
          <icon width="10" height="18" class="d-md-none" type="arrow-left"/>
        </template>
        <template #modal-title>
          {{ modalTitle }}
        </template>
        <ValidationObserver ref="projectPageForm" slim>
          <div class="position-relative-w-100">
            <p class="txt-red">
              {{ $t('pages.project-page.rules.camel-case') }}
              <span class="bold txt-bold">{{ $t('pages.project-page.rules.camel-case-eg') }}</span>
            </p>
          </div>
          <div class="edge edge-amount" >
            <h3 :content="$t('pages.project-page.modal.section-key')"></h3>
            <div class="row row-edit">
              <div class="col">
                <ValidatedField
                  type="text" id="key" name="key" class="mb-0" no-icon no-tooltip
                  v-model="projectPage.key"
                  :disabled="updatePending"
                  ref="fieldAmount"
                  :rules="rulesFor('key')"
                />
              </div>
            </div>
          </div>
          <div class="edge edge-amount">
            <h3 :content="$t('pages.project-page.modal.section-name')"></h3>
            <div class="row row-edit">
              <div class="col">
                <ValidatedField
                  type="text" id="description" name="description" class="mb-0" no-icon no-tooltip
                  v-model="projectPage.name"
                  :disabled="updatePending"
                  ref="fieldAmount"
                  :rules="rulesFor('name')"
                />
              </div>
            </div>
          </div>
        </ValidationObserver>
      </b-modal>

      <div class="panel position-relative panel-content">
        <Breadcrumb :items=breadCrumbs() v-if="loaded"/>
        <div class="list d-none d-md-block left-edge">
          <p class="head-line justify-content-between">
            <span>{{ $t('pages.project-page.title') }}</span>
            <search-filter
              v-model="filter"
              :disabled="!loaded || pending"
              :placeholder="$t('pages.project-page.filter-tip')"
              @input="onSearch()"
            />
            <spinner v-if="!loaded" /></p>
          <div class="position-relative-w-100">
            <p class="txt-red">
              {{ $t('pages.project-page.rules.camel-case') }}
              <span class="bold txt-bold">{{ $t('pages.project-page.rules.camel-case-eg') }}</span>
            </p>
          </div>
          <div class="plans-table" v-if="loaded">
            <table class="w-100">
              <thead>
                <tr>
                  <th class="w-id">{{ $t('id') }}</th>
                  <th class="w-name">{{ $t('pages.project-page.headers.key') }}</th>
                  <th class="w-occupancy text-center">{{ $t('pages.project-page.headers.name') }}</th>
                  <th class="w-actions">{{ $t('actions') }}</th>
                </tr>
              </thead>

              <tbody v-if="projectPages.length === 0">
                <tr>
                  <td colspan="4" class="w-empty">{{ $t('pages.project-page.no-project-page') }}</td>
                </tr>
              </tbody>
              <tbody v-for="row in projectPages" :key="row.id">
                <tr class="separator before"></tr>
                <tr>
                  <td>
                    {{ row.id }}
                  </td>
                  <td>
                    <p>{{ row.key }}</p>
                  </td>
                  <td>
                    {{ row.name }}
                  </td>
                  <td class="actions">
                    <b-btn class="btn-icon btn-tiny" @click="editProjectKey(row)" :disabled="updatePending"
                           v-if="!isTranslator">
                      <icon width="17" height="17" type="edit"
                            v-b-tooltip:page-channels.bottom="$t('pages.project-page.tooltips.edit')"
                      />
                    </b-btn>
                    <b-btn class="btn-icon btn-tiny" @click="removeProjectPage(row.id)" v-if="!isTranslator">
                      <icon width="19" height="19" type="delete"
                            v-b-tooltip:page-channels.bottom="$t('pages.project-page.tooltips.delete')"
                      />
                    </b-btn>
                    <b-btn class="btn-icon btn-tiny" @click="projectKeysUrl(row.id)" v-if="isAdmin || isDeveloper">
                      <icon width="19" height="19" type="connect"
                            v-b-tooltip:page-channels.bottom="$t('pages.project-page.tooltips.keys')"
                      />
                    </b-btn>
                    <b-btn class="btn-icon btn-tiny"
                           @click="projectTranslationsUrl(row.id)" v-if="isAdmin || isTranslator"
                    >
                      <icon width="19" height="19" type="globe"
                            v-b-tooltip:page-channels.bottom="$t('pages.project-page.tooltips.translations')"
                      />
                    </b-btn>
                  </td>
                </tr>
                <tr class="separator after"></tr>
              </tbody>
            </table>
          </div>
          <div v-if="loaded" :class="{'mb-4': isTranslator}">
            <b-btn v-if="!isTranslator" pill variant="outline-primary" class="add-new-plan"
                   @click="openCreateForm">
              <icon width="10" height="11" type="plus"/>
              {{ $t('pages.project-page.button-add') }}
            </b-btn>
          </div>
          <pagination
            v-if="loaded && totalCount && setPagination"
            :perPage="20"
            :currentPage="currentPage"
            :totalRows="totalCount"
            @update:current-page="updateCurrentPage($event)"
          />
        </div>
      </div>
      <div class="d-md-none list-item" v-if="noProjectPages">
        <div class="w-empty">{{ $t('pages.roomtypes.no-rooms') }}</div>
      </div>
      <div class="d-md-none add-new-plan-block" v-if="loaded">
        <b-btn pill variant="outline-primary" class="add-new-plan" @click="openCreateForm">
          <icon width="10" height="10" type="plus"/>
          {{ $t('pages.project-page.button-add') }}
        </b-btn>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState, mapGetters, mapActions } from 'vuex';

  export default {
    name: 'ProjectPage',
    props: {
      payload: {
        validator: (v) => ['object', 'undefined'].includes(typeof v),
        default: null,
      },
    },
    data: () => ({
      projectPage: {},
      currentPage: 1,
      filter: '',
      setPagination: true,
    }),
    async created() {
      this.resetProjectPageModal();
      await this.show();
    },
    computed: {
      ...mapGetters('projectPages', ['loaded', 'noProjectPages', 'projectPages']),
      ...mapState('projectPages', ['error', 'pending', 'updatePending', 'totalCount', 'project']),
      ...mapGetters('user', ['isAdmin', 'isDeveloper', 'isTranslator']),
      formValid() {
        return true;
      },
      modalTitle() {
        if (this.projectPage.id == null) {
          return this.$t('pages.project-page.modal.title-add');
        }
        const { id, name } = this.projectPage;
        return this.$t('pages.project-page.modal.title-edit', { id, name });
      },
    },
    methods: {
      ...mapActions('projectPages', ['fetchData', 'createProjectPage', 'updateProjectPage', 'deleteProjectPage']),

      modalScroll(ev) {
        const modal = ev.target;
        this.$nextTick(() => {
          if (modal != null) modal.scrollTop = 0;
        });
      },
      resetProjectPageModal() {
        this.projectPage = {
          key: '',
          name: '',
          project_id: '',
        };
        if (this.$refs.projectPageForm != null) {
          this.$refs.projectPageForm.reset();
        }
      },
      openCreateForm() {
        this.resetProjectPageModal();
        this.$nextTick(this.$refs.projectPageModal.show);
      },
      editProjectKey(projectPage) {
        this.projectPage = {};
        this.resetProjectPageModal();
        this.projectPage = {
          ...this.projectPage,
          ...JSON.parse(JSON.stringify(projectPage)), // deep clone without bindings
        };
        this.$nextTick(() => {
          this.$refs.projectPageForm.reset();
          this.$refs.projectPageModal.show();
        });
      },
      async processForm() {
        const projectPage = { ...this.projectPage };
        if (this.payload != null) {
          Object.keys(this.payload).forEach((k) => {
            projectPage[k] = this.payload[k];
          });
        }
        try {
          projectPage.project_id = this.$route.params.id;
          if (projectPage.id != null) {
            await this.updateProjectPage(projectPage);
          } else {
            await this.createProjectPage(projectPage);
          }
          this.$refs.projectPageModal.hide();
          this.$toastr.s({
            title: projectPage.id ? this.$t('pages.project-page.alert-edit') : this.$t('pages.project-page.alert-saved'),
            msg: '',
            timeout: 3000,
            progressbar: false,
          });
          await this.show();
        } catch (error) {
          this.$toastr.e(error.message, this.$t('error'));
        }
      },
      async show() {
        await this.fetchData({
          currentPage: this.currentPage,
          projectId: this.$route.params.id,
          q: this.filter,
        });
      },
      rulesFor(field) {
        const rules = {
          required: true,
        };
        switch (field) {
          case 'key':
            break;
          case 'name':
            break;
          default:
            break;
        }
        return rules;
      },
      updateCurrentPage(currentPage) {
        this.currentPage = currentPage;
        this.show();
      },
      projectKeysUrl(projectId) {
        this.$router.push({
          name: 'projects-keys',
          params: { id: projectId },
        });
      },
      projectTranslationsUrl(projectId) {
        this.$router.push({
          name: 'projects-translations',
          params: { id: projectId },
        });
      },
      breadCrumbs() {
        return [
          {
            text: this.$t('pages.dashboard.title'),
            to: { name: 'dashboard' },
          },
          {
            text: this.project.name,
            to: { name: 'projects' },
          },
          {
            text: this.$t('pages.project-page.title'),
            active: true,
          },
        ];
      },
      async removeProjectPage(projectPageId) {
        if (window.confirm(this.$t('pages.project-page.delete-modal.confirmation-msg'))) {
          await this.deleteProjectPage(projectPageId);
          await this.show();
          this.$toastr.s({
            title: this.$t('pages.project-page.alert-delete'),
            msg: '',
            timeout: 3000,
            progressbar: false,
          });
        }
      },
      async onSearch() {
        if (this.filter.length === 0 || this.filter.length >= 3) {
          if (this.filter.length >= 3) {
            this.setPagination = false;
          } else {
            this.setPagination = true;
          }
          await this.show();
        }
      },
    },
  };
</script>
